<template>
  <div>
    <transition name="fade">
      <div v-if="isOpen" class="sidebar-overlay" @click="$emit('close')"></div>
    </transition>

    <transition name="slide">
      <div v-if="isOpen" class="sidebar-content">
        <div class="sidebar-header">
          <img src="@/assets/images/arkayl_logo_clear.png" alt="Logo" class="mini-logo">
          <button class="close-btn" @click="$emit('close')">&times;</button>
        </div>

        <nav class="sidebar-nav">
          <router-link to="/services">{{ $t('menuServices') }}</router-link>
          <router-link to="/about-us">{{ $t('menuAbout') }}</router-link>
          <router-link to="/case-studies">{{ $t('caseStudies') }}</router-link>
          <router-link to="/contact" class="mobile-cta">{{ $t('menuContact') }}</router-link>
        </nav>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: Boolean
  }
}
</script>

<style scoped>
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
}

.sidebar-content {
  position: fixed;
  top: 0;
  right: 0; /* Sau left: 0, depinde de preferință */
  width: 280px;
  height: 100%;
  background: #F7F9FC;
  z-index: 1002;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.mini-logo { height: 40px; }

.close-btn {
  background: none;
  border: none;
  font-size: 30px;
  cursor: pointer;
  color: #000;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.sidebar-nav a {
  text-decoration: none;
  color: #062D45;
  font-weight: bold;
  font-size: 18px;
  text-transform: uppercase;
}

.mobile-cta {
  margin-top: 20px;
  padding: 12px;
  background-color: #062D45;
  color: white !important;
  text-align: center;
  border-radius: 8px;
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

.slide-enter-active, .slide-leave-active { transition: transform 0.3s ease; }
.slide-enter-from, .slide-leave-to { transform: translateX(100%); }
</style>
